import React from "react";
import { Link } from "react-router-dom";

const Brand = ({ size = "default", className = "" }) => {
  const sizes = {
    sm: "text-lg",
    default: "text-2xl",
    lg: "text-3xl md:text-4xl",
  };
  const dotSize = {
    sm: "w-1.5 h-1.5",
    default: "w-2 h-2",
    lg: "w-2.5 h-2.5",
  };
  return (
    <Link to="/" data-testid="brand-logo" className={`font-display ${sizes[size]} tracking-tighter font-medium inline-flex items-center gap-1.5 ${className}`}>
      <span className="relative inline-flex items-center">
        <span className="font-light">Snap</span>
        <span className="text-terracotta">Shop</span>
        <span className={`absolute -top-0.5 -right-2 ${dotSize[size]} rounded-full bg-terracotta`}></span>
      </span>
    </Link>
  );
};

export default Brand;
